import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { prefetchMovementPageDataFromApi, useMovementPageDataFromApi } from './pageData';

export type MovementPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useMovementPageDataFromApi>[0]>;
}>;

export type MovementPageCombinedState = ReturnType<typeof useMovementPageDataFromApi>;

export function usePageContext(
	slug: string,
	prefetchedData?: MovementPagePrefetchedContext,
): MovementPageCombinedState {
	return useMovementPageDataFromApi(prefetchedData?.pageData, slug);
}

export async function prefetchPageContext(
	slug: string,
	context: PrefetchContext,
): Promise<MovementPagePrefetchedContext> {
	return { pageData: await prefetchMovementPageDataFromApi(context, slug) };
}

export type MovementPagePrefetchedDataProps = PrefetchedDataProps<MovementPagePrefetchedContext>;
